import * as Portal from '@radix-ui/react-portal'
import ReactConfetti, { Props as ReactConfettiProps } from 'react-confetti'

import { useWindowSize } from '@/ui/utils/useWindowSize'

// @note: Without explicitly setting dimensions of ReactConfetti component,
// canvas size will default to initial window size and won't update on resize
// which can cause document to be stretched after layout changes.
// Rendered in portal to be independent of parent layout
export function Confetti(props: ReactConfettiProps) {
  const { width, height } = useWindowSize()
  const { style: confettiStyle, ...restProps } = props

  return (
    <Portal.Root style={{ position: 'fixed', top: 0, left: 0, pointerEvents: 'none', zIndex: confettiStyle?.zIndex }}>
      <ReactConfetti {...restProps} width={width} height={height} style={confettiStyle} />
    </Portal.Root>
  )
}
